a.prompt = (function(){
	return {
		create:function(s){
			// Input
			var question = s.question || '';
			var answerlist = s.answers || [];
			// Avoid multiple
			$('#prompt_container').remove();
			// Create prompt
			var cnt = '';
			cnt += '<div id="prompt_container">';
			cnt += '<div class="dialog">';
			cnt += '<div class="question">'+question+'</div>';
			cnt += '<ul>';
			if (answerlist.length>0) {
				answerlist.forEach(function(e){
					cnt += '<li>'+e.value+'</li>';
				});
			}
			cnt += '<li class="cancel">Cancel</li>';
			cnt += '</ul>';
			cnt += '</div>';
			cnt += '</div>';
			$('body').append(cnt);
			// Bind
			$('#prompt_container ul li').unbind('click').click(function(){
				if (answerlist.length>0 && answerlist[$(this).index()]) {
					answerlist[$(this).index()].action();
					a.prompt.close();
				}
				else {
					a.prompt.close();
				}
			});
		},
		close:function(){
			$('#prompt_container').remove();
		}
	}
}());